import api from "../services/api";

// The prices a product has in its price lists, newest entry first and without repeats: its sales prices for "sales"
// (sales invoices / orders) or its purchase prices for "purchase" (purchase invoices). The dates on the price lists are
// not looked at. Empty when the product has no such price yet.
export const fetchProductPrices = async (productId, kind) => {
  const priceLists = await api.get("/api/v1/products/price-lists", { productId });
  const prices = [];
  (Array.isArray(priceLists) ? priceLists : [])
    .filter((p) => p.active)
    .sort((a, b) => b.id - a.id)
    .forEach((p) => {
      const price = Number(kind === "purchase" ? p.purchasePrice : p.basePrice);
      if (price > 0 && !prices.includes(price)) prices.push(price);
    });
  return prices;
};

// Once an item row's product is picked: fills its unit price with the product's newest price and keeps all its prices on
// the row (priceOptions) for the price dropdown. With keepPrice the row's own price is left as it is (rows of an invoice
// opened for editing). The row is left alone if its product was changed again while the prices were loading.
export const fillUnitPrice = async (setFormData, index, productId, kind, keepPrice = false) => {
  if (!productId) return;
  let prices = [];
  try {
    prices = await fetchProductPrices(productId, kind);
  } catch {
    return;
  }
  setFormData((prev) => {
    const items = [...prev.items];
    if (!items[index] || String(items[index].productId) !== String(productId)) return prev;
    items[index] = { ...items[index], priceOptions: prices };
    if (!keepPrice && prices.length) items[index].unitPrice = String(prices[0]);
    return { ...prev, items };
  });
};
